import { render, staticRenderFns } from "./DemandaForm.vue?vue&type=template&id=17644669&"
import script from "./DemandaForm.vue?vue&type=script&lang=js&"
export * from "./DemandaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports